"use strict";

var cov_kampgu7fm = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/file/File.context.js";
  var hash = "4bcbca453d15312292154fd4a9e432e03d2c1b9b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/file/File.context.js",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 27
        },
        end: {
          line: 10,
          column: 48
        }
      },
      "1": {
        start: {
          line: 22,
          column: 43
        },
        end: {
          line: 22,
          column: 76
        }
      },
      "2": {
        start: {
          line: 23,
          column: 62
        },
        end: {
          line: 23,
          column: 91
        }
      },
      "3": {
        start: {
          line: 27,
          column: 6
        },
        end: {
          line: 32,
          column: 4
        }
      },
      "4": {
        start: {
          line: 34,
          column: 18
        },
        end: {
          line: 40,
          column: 3
        }
      },
      "5": {
        start: {
          line: 42,
          column: 2
        },
        end: {
          line: 46,
          column: 4
        }
      },
      "6": {
        start: {
          line: 49,
          column: 0
        },
        end: {
          line: 89,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "FileContextProvider",
        decl: {
          start: {
            line: 12,
            column: 16
          },
          end: {
            line: 12,
            column: 35
          }
        },
        loc: {
          start: {
            line: 21,
            column: 3
          },
          end: {
            line: 47,
            column: 1
          }
        },
        line: 21
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 28,
            column: 12
          },
          end: {
            line: 28,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 28,
            column: 12
          },
          end: {
            line: 28,
            column: 19
          }
        }, {
          start: {
            line: 28,
            column: 23
          },
          end: {
            line: 28,
            column: 36
          }
        }],
        line: 28
      },
      "1": {
        loc: {
          start: {
            line: 29,
            column: 20
          },
          end: {
            line: 29,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 29,
            column: 20
          },
          end: {
            line: 29,
            column: 35
          }
        }, {
          start: {
            line: 29,
            column: 39
          },
          end: {
            line: 29,
            column: 60
          }
        }],
        line: 29
      },
      "2": {
        loc: {
          start: {
            line: 30,
            column: 16
          },
          end: {
            line: 30,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 16
          },
          end: {
            line: 30,
            column: 27
          }
        }, {
          start: {
            line: 30,
            column: 31
          },
          end: {
            line: 30,
            column: 48
          }
        }],
        line: 30
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "4bcbca453d15312292154fd4a9e432e03d2c1b9b"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileContextProvider = FileContextProvider;
exports.FileContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("../..");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var FileContext = (cov_kampgu7fm.s[0]++, _react.default.createContext());
exports.FileContext = FileContext;

function FileContextProvider(_ref) {
  var _config = _ref.config,
      _authentication = _ref.authentication,
      _repository = _ref.repository,
      filepath = _ref.filepath,
      onFilepath = _ref.onFilepath,
      defaultContent = _ref.defaultContent,
      create = _ref.create,
      children = _ref.children;
  cov_kampgu7fm.f[0]++;

  var _ref2 = (cov_kampgu7fm.s[1]++, (0, _react.useContext)(_.AuthenticationContext)),
      contextAuthentication = _ref2.state;

  var _ref3 = (cov_kampgu7fm.s[2]++, (0, _react.useContext)(_.RepositoryContext)),
      contextRepository = _ref3.state,
      contextConfig = _ref3.config;

  var _ref4 = (cov_kampgu7fm.s[3]++, (0, _.useFile)({
    config: (cov_kampgu7fm.b[0][0]++, _config) || (cov_kampgu7fm.b[0][1]++, contextConfig),
    authentication: (cov_kampgu7fm.b[1][0]++, _authentication) || (cov_kampgu7fm.b[1][1]++, contextAuthentication),
    repository: (cov_kampgu7fm.b[2][0]++, _repository) || (cov_kampgu7fm.b[2][1]++, contextRepository),
    filepath: filepath,
    onFilepath: onFilepath,
    defaultContent: defaultContent,
    create: create
  })),
      state = _ref4.state,
      actions = _ref4.actions,
      component = _ref4.component,
      components = _ref4.components,
      config = _ref4.config;

  var context = (cov_kampgu7fm.s[4]++, {
    state: state,
    actions: actions,
    component: component,
    components: components,
    config: config
  });
  cov_kampgu7fm.s[5]++;
  return /*#__PURE__*/_react.default.createElement(FileContext.Provider, {
    value: context
  }, children);
}

;
cov_kampgu7fm.s[6]++;
FileContextProvider.propTypes = {
  /** The full filepath for the file. */
  filepath: _propTypes.default.string,

  /** Function to propogate filepath when the Blob is selected. */
  onFilepath: _propTypes.default.func,

  /** The default string to populate the file if it doesn't exist */
  defaultContent: _propTypes.default.string,

  /** use a form to create a new file */
  create: _propTypes.default.bool,

  /** Authentication object returned from a successful withAuthentication login. */
  config: _propTypes.default.shape({
    server: _propTypes.default.string.isRequired,
    headers: _propTypes.default.shape({
      Authorization: _propTypes.default.string.isRequired
    })
  }),
  authentication: _propTypes.default.shape({
    config: _propTypes.default.shape({
      server: _propTypes.default.string.isRequired,
      headers: _propTypes.default.shape({
        Authorization: _propTypes.default.string.isRequired
      }).isRequired
    }).isRequired,
    user: _propTypes.default.shape({
      username: _propTypes.default.string.isRequired,
      email: _propTypes.default.string.isRequired
    }).isRequired
  }),

  /** Repository tree_url can be used in place of blobConfig */
  repository: _propTypes.default.shape({
    owner: _propTypes.default.shape({
      username: _propTypes.default.string.isRequired
    }),
    name: _propTypes.default.string.isRequired
  }),

  /** Children to render inside of Provider */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired
};